module.exports = {"TXTCLI_Search":{"id":"TXTCLI_Search","defaultMessage":"Rechercher","flags":["TRACK"],"track":"Search"}}